import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import step1 from '../../../assets/img/home/step-by-step/step1.png'
import step2 from '../../../assets/img/home/step-by-step/step2.png'
import step3 from '../../../assets/img/home/step-by-step/step3.png'
import { StartCard } from "../components/StartInvestments";

export const StartInvestments = () => {
    return (
        <div className="container my-14 step-by-step">
            <div className="w-full text-center mt-14 mb-20">
                <h2 className="primaryFont font-bold text-3xl md:text-5xl">QUIERES EMPEZAR A</h2>
                <h2 className="mt-1 md:mt-3 primaryFont font-bold text-3xl md:text-5xl">INVERTIR EN INMUEBLES PERO...</h2>
            </div>
            <div className="w-full">
                <Swiper
                    slidesPerView={1}
                    spaceBetween={10}
                    pagination={true}
                    modules={[Pagination]}
                    className="mySwiper"
                    breakpoints={{
                        640: {
                            slidesPerView: 1,
                            spaceBetween: 50,
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 100,
                        }
                    }}
                >
                    <SwiperSlide>
                        <StartCard
                            src={step1}
                            key={1}
                            alt = {"INVIERTE EN PROYECTOS INMOBILIARIOS"}
                            title="1. No quieres el estrés de las deudas eternas y las hipotecas"
                            text="Invierte en proyectos inmobiliarios sin la carga de deudas a largo plazo."
                        />
                    </SwiperSlide>
                    <SwiperSlide>
                        <StartCard
                            src={step2}
                            key={2}
                            alt = {"RENTABILIDAD EN LAS INVERSIONES"}
                            title="2.  Como generar rentas y valorización sin complicaciones"
                            text="Obtén altas rentabilidades sin las complicaciones de manejar una propiedad."
                        />
                    </SwiperSlide>
                    <SwiperSlide>
                        <StartCard
                            src={step3}
                            key={3}
                            alt = {"INVERSION PARA LAS NUEVAS GENERACIONES"}
                            title="3. No quieres esperar una década para empezar a invertir"
                            text="Comienza con tus ahorros y gestiona tu crecimiento desde el primer año."
                        />
                    </SwiperSlide>
                </Swiper>

            </div>
        </div>
    )
}
